<template>
  <div ref="textWrap" class="text-wrap">
    <span
      ref="text"
      class="text"
      :class="{ 'is-scroll': isScroll }"
      :style="{ animationDuration: duration + 's', animationDelay: delay + 's' }"
    >
      {{ text }}
    </span>
  </div>
</template>

<script>
export default {
  name: "MarqueeText",

  props: {
    text: {
      type: String,
      default: ""
    },

    isTag: {
      type: String,
      default: "span"
    },

    duration: {
      type: Number,
      default: -1 // *秒
    },

    delay: {
      type: Number,
      default: 0 // * 毫秒
    }
  },

  data() {
    return {
      isScroll: false
    };
  },

  watch: {
    text() {
      this.init();
    }
  },

  async mounted() {
    this.init();
  },

  async beforeDestory() {
    if (this.$refs.text) {
      this.$refs.text.removeEventListener("transitionend", this.transitionend);
    }
    this.clearRollTimer();
  },

  methods: {
    init() {
      this.$nextTick(() => {
        if (this.$refs.textWrap && this.$refs.text) {
          const wrapBoundClient = this.$refs.textWrap.getBoundingClientRect();
          const wrapWidth = wrapBoundClient.width;
          // console.log('wrapWidth', wrapWidth);
          const textBoundClient = this.$refs.text.getBoundingClientRect();
          const textWidth = textBoundClient.width;
          // console.log('textWidth', textWidth);
          if (wrapWidth < textWidth) {
            this.isScroll = true;
          } else {
            this.isScroll = false;
          }
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.text-wrap {
  display: inline-block;
  overflow: hidden;
  max-width: 100%;

  .text {
    display: inline-block;
    pointer-events: none;
    white-space: nowrap;
    &.is-scroll {
      animation-name: text-scroll;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
    }
  }

  @keyframes text-scroll {
    0% {
      transform: translateX(0);
    }

    25% {
      transform: translateX(-50%);
    }

    50.001% {
      transform: translateX(-100%);
    }
    50.002% {
      transform: translateX(100%);
    }
    75% {
      transform: translateX(50%);
    }
    100% {
      transform: translateX(0);
    }
  }
}
</style>
